<template>
    <div class="wrapper-user">
      <b-container class="contentcontainer">
        <b-row class="contentcontainer__head">
          <b-col>
            <h2> {{$t("user.invoices.costscurrent")}}</h2>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col>
            <table class="table table--overview">
              <tbody>
              <tr>
                <td>
                  {{$t("user.invoices.plan")}}
                </td>
                <td>
                  <span class="amount">
                    {{ plan }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{$t("user.invoices.site")}}
                </td>
                <td>
                  <span class="amount">
                    {{ site }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{$t("user.invoices.backuptest")}}
                </td>
                <td>
                  <span class="amount">
                    {{ backuptest }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {{$t("user.invoices.total")}}
                </td>
                <td>
                  <strong>
                    <span class="amount">
                      {{ balance }}
                    </span>
                  </strong>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="contentcontainer">
        <b-row class="contentcontainer__head">
          <b-col>
            <h2> {{$t("user.invoices.titlelist")}}</h2>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col>
            <InvoicesList></InvoicesList>
          </b-col>
        </b-row>
      </b-container>
    </div>
</template>

<script>

import { mapState } from 'vuex'

import InvoicesList from './InvoicesList'

export default {

  name: 'Invoices',

  components: {
    InvoicesList
  },

  computed: {
    ...mapState('invoice', {
      costCurrentMonth: state => state.costCurrentMonth,
      items: state => state.items
    }),

    balance () {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.costCurrentMonth.total / 100)
    },

    plan () {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.costCurrentMonth.plan / 100)
    },

    site () {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.costCurrentMonth.site / 100)
    },

    backuptest () {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.costCurrentMonth.backuptest / 100)
    }
  }
}
</script>
